import {HttpContextToken} from '@angular/common/http';

export const NO_SEND_HEADER = new HttpContextToken<boolean>(() => false);
export const IGNORE_ERROR = new HttpContextToken<boolean>(() => false);
